import { useState, useEffect, useRef } from 'react';
import './section.scss';

const Section: React.FC<{ children: React.ReactNode; isPageBreakAvoidOnPrint?: boolean }> = ({
  children,
  isPageBreakAvoidOnPrint,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    const node = sectionRef.current;
    if (node) observer.observe(node);

    return () => {
      if (node) observer.unobserve(node);
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className={`card section ${isVisible ? 'visible' : ''}  shadow-sm  p-2 mb-3 ${isPageBreakAvoidOnPrint ? 'print-no-break-inside' : ''}`}
    >
      {children}
    </div>
  );
};

export default Section;
